const renewableMenuPin = (() => {
  if (document.querySelector("body#pageRenewableenergy") !== null) {
    if (document.querySelector("section#jsSecMenu") !== null) {



      let sW = window.innerWidth;

      if (sW > 768) {

      } else {

        let headerH = document.querySelector('header.header').clientHeight;

        let secMenu = document.querySelector('#jsSecMenu')
        let menuWrapOuter = secMenu.querySelector('.js-menu-wrap-outer')

        gsap.to('#jsSecMenu .js-menu-wrap-outer', {
          scrollTrigger: {
            invalidateOnRefresh: true,
            trigger: '#jsSecMenu .js-menu-wrap-outer',
            start: `0% ${headerH}px`,
            endTrigger: 'body',
            end: '100% 0%',
            pin: true,
            pinSpacing: false,
            onEnter: () => menuWrapOuter.classList.add('is-act'),
            // onLeave: () => console.log("onLeave"),
            // onEnterBack: () => console.log("onEnterBack"),
            onLeaveBack: () => menuWrapOuter.classList.remove('is-act'),
            // markers: true
          }
        });
      }



    }
  }
})()
export default renewableMenuPin;